import { createContext, useContext, useState, useCallback, useMemo } from 'react';

const SidebarContext = createContext(null);

export const useSidebarContext = () => {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error('useSidebarContext must be used within a SidebarProvider');
    }
    return context;
};

export function SidebarProvider({ children }) {
    const [isOpen, setIsOpen] = useState(true);
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggle = useCallback(() => setIsOpen((prev) => !prev), []);
    const toggleCollapse = useCallback(() => setIsCollapsed((prev) => !prev), []);

    const value = useMemo(
        () => ({ isOpen, isCollapsed, setIsOpen, setIsCollapsed, toggle, toggleCollapse }),
        [isOpen, isCollapsed, toggle, toggleCollapse]
    );

    return (
        <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
    );
}

export default SidebarContext;
